import type { ReactNode } from "react";
import { tokens } from "@core/theme/tokens";
import { tablePadding, tableSpacing } from "@core/table";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): el contenedor de la tabla
// (borde redondeado, texto "Cargando…", envoltorio de scroll horizontal,
// fila de encabezado a partir de `COLS`/`headers`, columna final
// "Acciones") era el mismo marcado palabra por palabra en
// benefits/BenefitsScreen.tsx y offers/OffersScreen.tsx. Cada pantalla sigue
// componiendo su propia fila de datos vía `renderRow`, que es donde de
// verdad difieren (columnas, ícono, chips de estado). `renderRow` recibe
// cada elemento ya con su propio `key`, para no envolverlo en un `<div>`
// extra que no existía en el marcado original. Extracción sin cambio de
// comportamiento ni de valores visuales: ninguna pantalla que la use cambia
// un pixel por esto.
export function ListingTablePanel<T>({
  loading,
  rows,
  columns,
  headers,
  minWidth = 1040,
  renderRow,
  empty,
}: {
  loading: boolean;
  rows: T[];
  columns: string;
  headers: string[];
  minWidth?: number;
  renderRow: (row: T) => ReactNode;
  empty: ReactNode;
}) {
  return (
    <div
      style={{
        border: `1px solid ${tokens.surface.line}`,
        borderRadius: 18,
        background: tokens.surface.bg2,
      }}
    >
      {loading ? (
        <div style={{ padding: 24, color: tokens.text.tertiary }}>
          Cargando…
        </div>
      ) : rows.length === 0 ? (
        empty
      ) : (
        <div style={{ overflowX: "auto" }}>
          <div style={{ minWidth }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: columns,
                gap: tableSpacing.columnGap,
                alignItems: "center",
                padding: tablePadding("18px", "11px"),
                borderBottom: `1px solid ${tokens.surface.line}`,
              }}
            >
              {headers.map((h) => (
                <span key={h} className="label">
                  {h}
                </span>
              ))}
              <span className="label" style={{ textAlign: "right" }}>
                Acciones
              </span>
            </div>
            {rows.map((row) => renderRow(row))}
          </div>
        </div>
      )}
    </div>
  );
}
